import React from "react";
import {Modal} from "react-bootstrap";
import {EMPTY_FUNCTION} from "../helpers";

export let InformationModal = ({
                                   title,
                                   hideHeader = false,
                                   body,
                                   showCloseButton = false,
                                   closeButtonText,
                                   onHide = () => {
                                   },
                                   controls,
                                   modalProps,
                                   error,
                                   size = 'md',
                                   footerClassName = '',
                                   footerStartContent = <></>,
                                   staticBackdrop = true, // or 'static'
                                   onBackdropClick = EMPTY_FUNCTION
                               }) => {
    let onHideInternal = () => {
        onHide()
        controls.hide()
    }

    return <Modal show={controls.isVisible}
                  onHide={onHideInternal}

                  animation={true}
                  backdrop={staticBackdrop}
                  centered={true}
                  {...modalProps}
                  contentClassName={"border-0"}
                  size={size}>

        {!hideHeader && <Modal.Header closeButton={showCloseButton}>
            <Modal.Title>{title}</Modal.Title>
        </Modal.Header>}
        {body && <Modal.Body>
            {body}
        </Modal.Body>}
    </Modal>
}